import { render, staticRenderFns } from "./update-log.vue?vue&type=template&id=40ef6408&scoped=true"
import script from "./update-log.vue?vue&type=script&lang=js"
export * from "./update-log.vue?vue&type=script&lang=js"
import style0 from "./update-log.vue?vue&type=style&index=0&id=40ef6408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef6408",
  null
  
)

export default component.exports